function L(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function U(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var r = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
const G = {
  100: "#F3F4F8",
  200: "#E6E8F0",
  300: "#B3B5BD",
  400: "#9496A1",
  500: "#777986",
  600: "#5B5D6B",
  700: "#404252",
  800: "#282A3A",
  900: "#101223"
}, O = {
  50: "#F4F5F8",
  100: "#EBEDF3",
  200: "#D2D6E3",
  300: "#A5ADC7",
  400: "#4A5A8F",
  500: "#1D3173",
  600: "#17275C",
  700: "#001840",
  800: "#0C142E"
}, A = {
  50: "#F7FBF3",
  100: "#EEF6E8",
  200: "#DEEDD1",
  300: "#BCDBA3",
  400: "#79B846",
  500: "#58A618",
  600: "#468513",
  700: "#35640E",
  800: "#23420A"
}, H = {
  50: "#E6EDEB",
  100: "#CDDAD7",
  200: "#9AB5AF",
  300: "#689088",
  400: "#356B60",
  500: "#034638",
  600: "#002A20",
  700: "#00261D",
  800: "#00221A"
}, W = {
  100: "#FEF7F1",
  200: "#FCECDA",
  300: "#FAE2C6",
  400: "#DF7B00",
  500: "#C96F00",
  600: "#B26200",
  700: "#BA5D00",
  800: "#A75400",
  900: "#954A00",
  1e3: "#803F00"
}, J = {
  50: "#FFF8F4",
  100: "#FFF0E6",
  200: "#FFC399",
  300: "#FFA566",
  400: "#BC3D00",
  500: "#FF6900",
  600: "#EB4C00",
  700: "#D44400",
  800: "#BC3D00"
}, Q = {
  100: "#FCF171",
  500: "#FBBE09"
}, X = {
  100: "#FCF3F3",
  200: "#F8E2E2",
  300: "#F3CECE",
  400: "#D21C1C",
  500: "#B91919",
  600: "#9D1515",
  700: "#970C0C",
  800: "#890B0B",
  900: "#6D0909",
  1e3: "#760909"
}, Y = (e) => ({
  content: ["./index.html", "./lib/**/*.{vue,js,ts,jsx,tsx}", "./src/**/*.{vue,js,ts,jsx,tsx}"],
  theme: {
    extend: {
      colors: {
        primary: e === "ro" ? J : A,
        secondary: e === "ro" ? H : O,
        transparent: "transparent",
        current: "currentColor",
        black: "#000000",
        white: "#FFFFFF",
        gray: G,
        blue: O,
        green: A,
        orange: W,
        yellow: Q,
        red: X
      },
      fontFamily: {
        sans: ["Ubuntu", "sans-serif"]
      },
      fontSize: {
        "desktop-body-s": ["0.75rem", "1rem"],
        // fz 12px lh 16px
        "desktop-body-m": ["0.875rem", "1.25rem"],
        // fz 14px lh 20px
        "desktop-body-l": ["1rem", "1.5rem"],
        // fz 16px lh 24px
        "desktop-headline-s": ["0.875rem", "1rem"],
        // fz 14px lh 16px
        "desktop-headline-m": ["1.125rem", "1.25rem"],
        // fz 18px lh 20px
        "desktop-headline-l": ["1.5rem", "1.75rem"],
        // fz 24px lh 28px
        "desktop-headline-xl": ["1.875rem", "2.125rem"],
        // fz 30px lh 34px
        "desktop-headline-xxl": ["2.25rem", "2.5625rem"],
        // fz 36px lh 41px
        "desktop-headline-xxxl": ["2.625rem", "3rem"],
        // fz 42px lh 48px
        "mobile-caption-m": ["0.75rem", "1rem"],
        // fz 12px lh 16px
        "mobile-caption-l": ["0.8125rem", "1.125rem"],
        // fz 13px lh 18px
        "mobile-body-s": ["0.8125rem", "1.25rem"],
        // fz 13px lh 20px
        "mobile-body-m": ["0.9375rem", "1.25rem"],
        // fz 15px lh 20px
        "mobile-body-l": ["1.0625rem", "1.375rem"],
        // fz 17px lh 22px
        "mobile-headline-l": ["1.25rem", "1.5625rem"],
        // fz 20px lh 25px
        "mobile-headline-xl": ["1.375rem", "1.75rem"],
        // fz 22px lh 28px
        "mobile-headline-xxl": ["1.75rem", "2.125rem"],
        // fz 28px lh 34px
        "mobile-headline-xxxl": ["2.125rem", "2.5625rem"]
        // fz 34px lh 41px
      },
      boxShadow: {
        thin: "0 0 1px 2px",
        "level-1": "0px 0px 2px #4F5E711F, 0px 2px 4px #4F5E711C, 0px 4px 8px #4F5E711A",
        "level-2": "0px 0px 2px #4F5E711F, 0px 2px 4px #4F5E711C, 0px 4px 8px #4F5E711A, 0px 16px 32px #4F5E7117",
        "level-3": "0px 0px 2px #4F5E711F, 0px 2px 4px #4F5E711C, 0px 4px 8px #4F5E711A, 0px 8px 16px #4F5E7117, 0px 16px 32px #4F5E7114",
        "level-3-flipped-y": "0px 0px 2px #4F5E711F, 0px -2px 4px #4F5E711C, 0px -4px 8px #4F5E711A, 0px -8px 16px #4F5E7117, 0px -16px 32px #4F5E7114",
        "level-4": "0px 0px 2px #4F5E711F, 0px 2px 4px #4F5E711C, 0px 4px 8px #4F5E711A, 0px 8px 16px #4F5E7117, 0px 16px 32px #4F5E7114, 0px 32px 64px #4F5E7112",
        "level-4-flipped-y": "0px 0px 2px #4F5E711F, 0px -2px 4px #4F5E711C, 0px -4px 8px #4F5E711A, 0px -8px 16px #4F5E7117, 0px -16px 32px #4F5E7114, 0px -32px 64px #4F5E7112"
      }
    }
  }
}), K = Y("cz"), Z = {
  ...K,
  content: ["./lib/**/*.{vue,js,ts,jsx,tsx}"]
};
var T = {}, V = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(o, r) {
    return {
      handler: o,
      config: r
    };
  }
  t.withOptions = function(o, r = () => ({})) {
    const i = function(s) {
      return {
        __options: s,
        handler: o(s),
        config: r(s)
      };
    };
    return i.__isOptionsFunction = !0, i.__pluginFunction = o, i.__configFunction = r, i;
  };
  const n = t;
})(V);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(V);
  function n(r) {
    return r.__esModule ? r : {
      default: r
    };
  }
  const o = t.default;
})(T);
let k = T;
var R = (k.__esModule ? k : { default: k }).default;
const ee = {}, te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ee
}, Symbol.toStringTag, { value: "Module" })), ne = /* @__PURE__ */ U(te);
/**
* (c) Iconify for Tailwind CSS
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 1.2.0
*/
var re = R, B = ne;
const oe = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), E = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), _ = Object.freeze({
  ...oe,
  ...E
}), ie = Object.freeze({
  ..._,
  body: "",
  hidden: !1
});
function se(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function I(e, t) {
  const n = se(e, t);
  for (const o in ie)
    o in E ? o in e && !(o in n) && (n[o] = E[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function le(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  function i(s) {
    if (n[s])
      return r[s] = [];
    if (!(s in r)) {
      r[s] = null;
      const l = o[s] && o[s].parent, c = l && i(l);
      c && (r[s] = [l].concat(c));
    }
    return r[s];
  }
  return t.forEach(i), r;
}
function P(e, t, n) {
  const o = e.icons, r = e.aliases || /* @__PURE__ */ Object.create(null);
  let i = {};
  function s(l) {
    i = I(
      o[l] || r[l],
      i
    );
  }
  return s(t), n.forEach(s), I(e, i);
}
function $(e, t) {
  if (e.icons[t])
    return P(e, t, []);
  const n = le(e, [t])[t];
  return n ? P(e, t, n) : null;
}
function ae(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
const ce = /(-?[0-9.]*[0-9]+[0-9.]*)/g, ue = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function w(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(ce);
  if (o === null || !o.length)
    return e;
  const r = [];
  let i = o.shift(), s = ue.test(i);
  for (; ; ) {
    if (s) {
      const l = parseFloat(i);
      isNaN(l) ? r.push(i) : r.push(Math.ceil(l * t * n) / n);
    } else
      r.push(i);
    if (i = o.shift(), i === void 0)
      return r.join("");
    s = !s;
  }
}
function fe(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function de(e) {
  return "data:image/svg+xml," + fe(e);
}
function me(e) {
  return 'url("' + de(e) + '")';
}
function pe(e) {
  const [t, n, o, r] = e;
  if (o !== r) {
    const i = Math.max(o, r);
    return [t - (i - o) / 2, n - (i - r) / 2, i, i];
  }
  return e;
}
const xe = Object.freeze({
  width: null,
  height: null
}), he = Object.freeze({
  // Dimensions
  ...xe,
  // Transformations
  ...E
});
function ge(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const r = e.indexOf(">", o), i = e.indexOf("</" + t);
    if (r === -1 || i === -1)
      break;
    const s = e.indexOf(">", i);
    if (s === -1)
      break;
    n += e.slice(r + 1, i).trim(), e = e.slice(0, o).trim() + e.slice(s + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function Fe(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function be(e, t, n) {
  const o = ge(e);
  return Fe(o.defs, t + o.content + n);
}
const ve = (e) => e === "unset" || e === "undefined" || e === "none";
function ye(e, t) {
  const n = {
    ..._,
    ...e
  }, o = {
    ...he,
    ...t
  }, r = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let i = n.body;
  [n, o].forEach((x) => {
    const f = [], F = x.hFlip, v = x.vFlip;
    let m = x.rotate;
    F ? v ? m += 2 : (f.push(
      "translate(" + (r.width + r.left).toString() + " " + (0 - r.top).toString() + ")"
    ), f.push("scale(-1 1)"), r.top = r.left = 0) : v && (f.push(
      "translate(" + (0 - r.left).toString() + " " + (r.height + r.top).toString() + ")"
    ), f.push("scale(1 -1)"), r.top = r.left = 0);
    let h;
    switch (m < 0 && (m -= Math.floor(m / 4) * 4), m = m % 4, m) {
      case 1:
        h = r.height / 2 + r.top, f.unshift(
          "rotate(90 " + h.toString() + " " + h.toString() + ")"
        );
        break;
      case 2:
        f.unshift(
          "rotate(180 " + (r.width / 2 + r.left).toString() + " " + (r.height / 2 + r.top).toString() + ")"
        );
        break;
      case 3:
        h = r.width / 2 + r.left, f.unshift(
          "rotate(-90 " + h.toString() + " " + h.toString() + ")"
        );
        break;
    }
    m % 2 === 1 && (r.left !== r.top && (h = r.left, r.left = r.top, r.top = h), r.width !== r.height && (h = r.width, r.width = r.height, r.height = h)), f.length && (i = be(
      i,
      '<g transform="' + f.join(" ") + '">',
      "</g>"
    ));
  });
  const s = o.width, l = o.height, c = r.width, a = r.height;
  let u, d;
  s === null ? (d = l === null ? "1em" : l === "auto" ? a : l, u = w(d, c / a)) : (u = s === "auto" ? c : s, d = l === null ? w(u, a / c) : l === "auto" ? a : l);
  const p = {}, b = (x, f) => {
    ve(f) || (p[x] = f.toString());
  };
  b("width", u), b("height", d);
  const g = [r.left, r.top, c, a];
  return p.viewBox = g.join(" "), {
    attributes: p,
    viewBox: g,
    body: i
  };
}
function Ee(e) {
  const t = {
    display: "inline-block",
    width: "1em",
    height: "1em"
  }, n = e.varName;
  switch (e.pseudoSelector && (t.content = "''"), e.mode) {
    case "background":
      n && (t["background-image"] = "var(--" + n + ")"), t["background-repeat"] = "no-repeat", t["background-size"] = "100% 100%";
      break;
    case "mask":
      t["background-color"] = "currentColor", n && (t["mask-image"] = t["-webkit-mask-image"] = "var(--" + n + ")"), t["mask-repeat"] = t["-webkit-mask-repeat"] = "no-repeat", t["mask-size"] = t["-webkit-mask-size"] = "100% 100%";
      break;
  }
  return t;
}
function ke(e, t) {
  const n = {}, o = t.varName, r = ye(e);
  let i = r.viewBox;
  i[2] !== i[3] && (t.forceSquare ? i = pe(i) : n.width = w("1em", i[2] / i[3]));
  const s = ae(
    r.body.replace(/currentColor/g, t.color || "black"),
    {
      viewBox: `${i[0]} ${i[1]} ${i[2]} ${i[3]}`,
      width: `${i[2]}`,
      height: `${i[3]}`
    }
  ), l = me(s);
  if (o)
    n["--" + o] = l;
  else
    switch (t.mode) {
      case "background":
        n["background-image"] = l;
        break;
      case "mask":
        n["mask-image"] = n["-webkit-mask-image"] = l;
        break;
    }
  return n;
}
const z = ".icon--{prefix}", M = ".icon--{prefix}--{name}", we = {
  commonSelector: z,
  iconSelector: M,
  overrideSelector: z + M
};
function Se(e, t, n = {}) {
  const o = [], r = [], i = n.color ? !0 : void 0;
  let s = n.mode || typeof i == "boolean" && (i ? "background" : "mask");
  if (!s) {
    for (let F = 0; F < t.length; F++) {
      const v = t[F], m = $(e, v);
      if (m) {
        s = (n.customise ? n.customise(m.body, v) : m.body).includes("currentColor") ? "mask" : "background";
        break;
      }
    }
    s || (s = "mask", r.push(
      "/* cannot detect icon mode: not set in options and icon set is missing info, rendering as " + s + " */"
    ));
  }
  let l = n.varName;
  l === void 0 && s === "mask" && (l = "svg");
  const c = {
    ...n,
    // Override mode and varName
    mode: s,
    varName: l
  }, { commonSelector: a, iconSelector: u, overrideSelector: d } = c.iconSelector ? c : we, p = u.replace(
    /{prefix}/g,
    e.prefix
  ), b = {
    ...n.rules,
    ...Ee(c)
  }, g = a && a !== u, x = /* @__PURE__ */ new Set();
  g && o.push({
    selector: a.replace(/{prefix}/g, e.prefix),
    rules: b
  });
  for (let F = 0; F < t.length; F++) {
    const v = t[F], m = $(e, v);
    if (!m) {
      r.push("/* Could not find icon: " + v + " */");
      continue;
    }
    const h = n.customise ? n.customise(m.body, v) : m.body, C = ke(
      {
        ..._,
        ...m,
        body: h
      },
      c
    );
    let D = !1;
    if (g && d)
      for (const q in C)
        q in b && (D = !0);
    const j = (D && d ? d.replace(/{prefix}/g, e.prefix) : p).replace(/{name}/g, v);
    o.push({
      selector: j,
      rules: C
    }), g || x.add(j);
  }
  const f = {
    css: o,
    errors: r
  };
  if (!g && x.size) {
    const F = Array.from(x).join(
      c.format === "compressed" ? "," : ", "
    );
    f.common = {
      selector: F,
      rules: b
    };
  }
  return f;
}
const S = /^[a-z0-9]+(-[a-z0-9]+)*$/;
function _e(e) {
  try {
    const t = require.resolve(`@iconify-json/${e}/icons.json`), n = require.resolve(`@iconify-json/${e}/info.json`);
    return {
      main: t,
      info: n
    };
  } catch {
  }
  try {
    return {
      main: require.resolve(`@iconify/json/json/${e}.json`)
    };
  } catch {
  }
}
const y = /* @__PURE__ */ Object.create(null);
function N(e) {
  try {
    const t = JSON.parse(B.readFileSync(e.main, "utf8"));
    return !t.info && e.info && (t.info = JSON.parse(B.readFileSync(e.info, "utf8"))), t;
  } catch {
  }
}
function Ce(e) {
  if (typeof e == "function")
    return e();
  if (typeof e == "object")
    return e;
  if (e.startsWith("{"))
    try {
      return JSON.parse(e);
    } catch {
    }
  if (y[e])
    return y[e];
  if (e.match(S)) {
    const n = _e(e);
    if (n) {
      const o = N(n);
      return o && (y[e] = o), o;
    }
  }
  const t = N({
    main: e
  });
  return t && (y[e] = t), t;
}
function De(e, t = {}) {
  var c, a;
  const n = e.split(/--|\:/);
  if (n.length !== 2)
    throw new Error(`Invalid icon name: "${e}"`);
  const [o, r] = n;
  if (!(o.match(S) && r.match(S)))
    throw new Error(`Invalid icon name: "${e}"`);
  const i = Ce(((c = t.iconSets) == null ? void 0 : c[o]) || o);
  if (!i)
    throw new Error(`Cannot load icon set for "${o}". Install "@iconify-json/${o}" as dev dependency?`);
  const s = Se(i, [r], {
    iconSelector: ".icon",
    customise: (u, d) => {
      var p;
      return ((p = t.customise) == null ? void 0 : p.call(t, u, d, o)) ?? u;
    }
  });
  if (s.css.length !== 1)
    throw new Error(`Cannot find "${e}". Bad icon name?`);
  const l = t.scale ?? 1;
  return l ? (s.common.rules.height = l + "em", s.common.rules.width = l + "em") : (delete s.common.rules.height, delete s.common.rules.width), {
    // Common rules
    ...t.overrideOnly || !((a = s.common) != null && a.rules) ? {} : s.common.rules,
    // Icon rules
    ...s.css[0].rules
  };
}
function je(e) {
  const t = (e == null ? void 0 : e.prefix) || "icon";
  return re(({ matchComponents: n }) => {
    n({
      [t]: (o) => {
        try {
          return De(o, e);
        } catch (r) {
          console.error(r.message);
        }
      }
    });
  });
}
var Oe = je, Ae = /* @__PURE__ */ Be(R);
function Be(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var Ie = (0, Ae.default)(function(t) {
  var n = t.matchUtilities, o = t.matchVariant, r = t.theme, i = function(a) {
    var u, d, p = (d = (u = a.match(/^(\d+\.\d+|\d+|\.\d+)\D+/)) === null || u === void 0 ? void 0 : u[1]) !== null && d !== void 0 ? d : null;
    return p === null ? null : parseFloat(a);
  }, s, l = (s = r("containers")) !== null && s !== void 0 ? s : {};
  n({
    "@container": function(c, a) {
      var u = a.modifier;
      return {
        "container-type": c,
        "container-name": u
      };
    }
  }, {
    values: {
      DEFAULT: "inline-size",
      normal: "normal"
    },
    modifiers: "any"
  }), o("@", function() {
    var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", a = (arguments.length > 1 ? arguments[1] : void 0).modifier, u = i(c);
    return u !== null ? "@container ".concat(a ?? "", " (min-width: ").concat(c, ")") : [];
  }, {
    values: l,
    sort: function(a, u) {
      var d = parseFloat(a.value), p = parseFloat(u.value);
      if (d === null || p === null) return 0;
      if (d - p !== 0) return d - p;
      var b, g = (b = a.modifier) !== null && b !== void 0 ? b : "", x, f = (x = u.modifier) !== null && x !== void 0 ? x : "";
      return g === "" && f !== "" ? 1 : g !== "" && f === "" ? -1 : g.localeCompare(f, "en", {
        numeric: !0
      });
    }
  });
}, {
  theme: {
    containers: {
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    }
  }
});
const Pe = /* @__PURE__ */ L(Ie), $e = {
  mode: "jit",
  content: [
    "./index.html",
    "./src/**/*.{vue,js,ts,jsx,tsx}",
    "./node_modules/@benu/ui-library/dist/*.{vue,js,ts,jsx,tsx}"
  ],
  presets: [Z],
  theme: {
    extend: {
      animation: {
        "expand-top": "expandFromTop 0.5s ease-out",
        "expand-left": "expandFromLeft 0.3s ease-out",
        "skeleton-loading": "skeleton-pulse 4s infinite ease-in-out"
      },
      keyframes: {
        expandFromTop: {
          "0%": { opacity: "0", transform: "scaleY(0)" },
          "100%": { opacity: "1", transform: "scaleY(1)" }
        },
        expandFromLeft: {
          "0%": { opacity: "0", transform: "translateX(100%)" },
          "100%": { opacity: "1", transform: "translateX(0)" }
        },
        "skeleton-pulse": {
          "0%": { backgroundPosition: "200% 0" },
          "50%": { backgroundPosition: "0% 0" },
          "100%": { backgroundPosition: "-200% 0" }
        }
      },
      screens: {
        "full-desktop": "1440px"
      },
      backgroundImage: {
        skeleton: "linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%)"
      },
      backgroundSize: {
        skeleton: "200% 100%"
      }
    }
  },
  plugins: [Oe({ prefix: "iconify" }), Pe]
};
export {
  L as g,
  $e as t
};
//# sourceMappingURL=tailwind.config-DKwLoSz6.js.map
